<button
  mat-stroked-button
  [matMenuTriggerFor]="menu"
  class="bulk-action-button"
  *ngIf="visible"
>
  Bulk actions <mat-icon>keyboard_arrow_down</mat-icon>
</button>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="taskService.toggleSelectedComplete()">
    <mat-icon>done</mat-icon>
    <span>Complete</span>
    <span class="shortcut">({{ ctrlOrCmd }} + ENTER)</span>
  </button>
  <button mat-menu-item (click)="taskService.launchAssignedTo()">
    <mat-icon>person_add</mat-icon>
    <span>Assign to</span>
    <span class="shortcut">(type '&#64;')</span>
  </button>
  <button mat-menu-item (click)="taskService.launchTag()">
    <mat-icon>sell</mat-icon>
    <span>Add tag</span>
    <span class="shortcut">(type '#')</span>
  </button>
  <!-- <button mat-menu-item>
    <mat-icon>content_copy</mat-icon>
    <span>Copy titles</span>
    <span class="shortcut">({{ ctrlOrCmd }} + C)</span>
  </button> -->
  <button mat-menu-item (click)="taskService.trashSelectedTasks()">
    <mat-icon>delete</mat-icon>
    <span>Trash tasks</span>
    <span class="shortcut">({{ backspaceOrDelete }})</span>
  </button>
</mat-menu>
